'use client';

interface ArrowUpToLineIconProps {
  size?: number;
  foreground?: string;
}

const LegacyArrowUpToLineIcon = ({ size = 24, foreground = '#ffffff' }: ArrowUpToLineIconProps) => {
  return (
    <svg
      stroke={foreground}
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 3h18"></path>
      <path d="m18 13-6-6-6 6"></path>
      <path d="M12 7v14"></path>
    </svg>
  );
};

export default LegacyArrowUpToLineIcon;
